import { Button } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

export default function News() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const getNews = () => {
    axios
      .post(
        "https://m1blog.aaragroups.com/blog/store-based-news-list-api/",
        {},
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        },
      )
      .then((res) => setData(res.data?.news_details || []))
      .catch((err) =>
        toast.error(err?.response?.data?.message || "Failed to fetch news"),
      );
  };

  const deleteNews = (id) => {
    axios
      .delete(
        `https://m1blog.aaragroups.com/blog/api/admin/api/news_deatils_api/?id=${id}`,
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        },
      )
      .then((res) => {
        toast.success(res?.data?.message);
        getNews();
      })
      .catch((err) =>
        toast.error(err?.response?.data?.message || "Failed to delete news"),
      );
  };

  useEffect(() => {
    getNews();
  }, []);

  return (
    <div className="p-0">
      <p className="my-3  sm:my-0 text-5xl text-center text-blue-900 underline">
        News
      </p>

      <div className="flex justify-end mb-2">
        <NavLink to="/addnews">
          <Button variant="outlined">Add News</Button>
        </NavLink>
      </div>

      <div className="flex flex-wrap gap-4">
        {data.length === 0 && (
          <p className="w-full text-center text-gray-500 mt-10">
            No news available
          </p>
        )}

        {data.map((item, idx) => (
          <div
            key={idx}
            className="flex flex-col md:flex-row border border-gray-300 rounded shadow-lg p-4 w-full md:w-5/12"
          >
            <div className="flex-1 flex flex-col items-center md:items-start">
              <p className="text-2xl font-semibold mb-2">{item.Title}</p>
              <p
                className="text-gray-700 text-sm mb-4"
                dangerouslySetInnerHTML={{ __html: item.Content }}
              />
            </div>

            {item.images && (
              <div className="flex flex-col items-center mt-3 md:mt-0 md:ml-4">
                <img
                  src={`${item.images}?${Date.now()}`}
                  alt={item.Title}
                  className="h-44 w-44 object-cover border"
                />
              </div>
            )}

            <div className="flex mt-4 md:mt-0 md:ml-auto gap-2">
              <Button
                variant="outlined"
                onClick={() =>
                  navigate(`/newsupdate/${item.id}`, { state: item })
                }
              >
                Update
              </Button>
              <Button
                variant="outlined"
                color="error"
                onClick={() => deleteNews(item.id)}
              >
                Delete
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
